import React from 'react'
import {
  Breadcrumb as BreadcrumbProps,
  useGlobalLabels,
  useSEOBreadcrumb,
} from '@sentecacommerce-theme/lib'
import { BreadcrumbsPlaceholder } from '../BreadcrumbsPlaceholder'
import { BreadcrumbItemList, Container, MainContainer } from './Components'

export const Breadcrumbs = (props: {
  data?: BreadcrumbProps
  isLoading?: boolean
  isInError?: boolean
  isCentered?: boolean
}) => {
  const { data, isLoading, isInError, isCentered } = props
  const { begin } = useGlobalLabels()

  const { elements, containerSeoProps } = useSEOBreadcrumb({
    data,
    homepageLabel: begin,
  })

  if (!elements?.length || isLoading) {
    return (
      <div className="d-flex align-items-center mt-4">
        <Container>
          <BreadcrumbsPlaceholder />
        </Container>
      </div>
    )
  }

  return (
    <MainContainer>
      <Container
        isInError={isInError}
        isCentered={isCentered}
        {...containerSeoProps}
      >
        <BreadcrumbItemList items={elements} />
      </Container>
    </MainContainer>
  )
}
